<template>
  <w-icon-wrapper icon-name='work-document-add-icon'>
    <path
      id="Pfad_55723"
      data-name="Pfad 55723"
      d="M5,7H8A1,1,0,0,0,8,5H5A1,1,0,0,0,5,7Z"
      fill="currentColor"
    />
    <path
      id="Pfad_55724"
      data-name="Pfad 55724"
      d="M5,11h5a1,1,0,0,0,0-2H5a1,1,0,0,0,0,2Z"
      fill="currentColor"
    />
    <path
      id="Pfad_55725"
      data-name="Pfad 55725"
      d="M4,14a1,1,0,0,0,1,1H15a1,1,0,0,0,0-2H5A1,1,0,0,0,4,14Z"
      fill="currentColor"
    />
    <path
      id="Pfad_55726"
      data-name="Pfad 55726"
      d="M15,17H5a1,1,0,0,0,0,2H15a1,1,0,0,0,0-2Z"
      fill="currentColor"
    />
    <path
      id="Pfad_55727"
      data-name="Pfad 55727"
      d="M22.24,1.76A6.059,6.059,0,0,0,18,0H0V24H20V11.65a5.769,5.769,0,0,0,2.24-1.41,5.987,5.987,0,0,0,0-8.48ZM18,22H2V2H13.54a5.976,5.976,0,0,0,.22,8.24A5.944,5.944,0,0,0,18,12ZM20,9.46A3.993,3.993,0,1,1,22,6,3.989,3.989,0,0,1,20,9.46Z"
      fill="currentColor"
    />
    <path
      id="Pfad_55728"
      data-name="Pfad 55728"
      d="M19.469,5.612h-1v-1a.5.5,0,0,0-1,0v1h-1a.5.5,0,0,0,0,1h1v1a.5.5,0,1,0,1,0v-1h1a.5.5,0,0,0,0-1Z"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconDocumentAdd' };
</script>
